import React from 'react';
import styles from './TipWrapper.module.scss';
import { RouteComponentProps, withRouter } from 'react-router';

/* Redux */
import { Dispatch } from 'redux';
import { tipsActions } from '../../../../store/tips/actions';
import { connect } from 'react-redux';
import { RootState } from '../../../../store';
import { LoginState } from '../../../../store/login/reducer';
import { TipsInfoState } from '../../../../store/tips/reducer';

/* Types */
import { TipRouterURLMatch } from '../interfaces/TipRouterURLMatch';
import { StoreTypesReversed } from '../../../PaymentGateway/interfaces/store_types';

/* Components */
import { BounceLoader } from 'react-spinners';
import { NotAvailableScreen } from '../../shared/components/NotAvailableScreen';
import { ShopHeader } from '../../shared/components/ShopHeader';

/* Utils */
import { get } from 'lodash';

/* Translations */
import { useTranslation } from 'react-i18next';
import { tr } from '../../../../utils/translations/translator';

/* Providers */
import { useTipProduct } from '../__hooks__/useTipProduct';
import { ShopContext } from '../../shared/__providers__/ShopContext';

export interface TipWrapperProps extends RouteComponentProps {
  getTipInfo: (tipID: string) => void;
  getCoupons: () => void;
  loginState: LoginState;
  match: TipRouterURLMatch;
  tipsInfoState: TipsInfoState;
}

export const TipWrapper: React.FC<TipWrapperProps> = ({
  getTipInfo,
  getCoupons,
  tipsInfoState,
  loginState,
  match,
}) => {
  const { id: tipID } = match.params;
  const { shop, isLoading, isUnavailable } = useTipProduct({
    getTipInfo,
    tipsInfoState,
    loginState,
    tipID,
    getCoupons,
  });

  const { t } = useTranslation();
  const tip = get(shop, ['products', 0]);

  return (
    <>
      {isLoading ? (
        <div className={styles.loadingWrapper}>
          <div className={styles.loading}>
            <BounceLoader color={'#27de81'} size={25} />
            <label>{tr(t, 'loading')} ...</label>
          </div>
        </div>
      ) : isUnavailable || !shop || !tip ? (
        <NotAvailableScreen title={tr(t, 'deleted-tip')} />
      ) : (
        <ShopContext.Provider value={{ shop }}>
          <ShopHeader
            product={shop.selectedProduct}
            store={StoreTypesReversed.TipPurchase}
            tipsterInfo={shop.tipsterInfo}
            isTipster={loginState.user?.user.is_tipster}
          ></ShopHeader>
          {tip.render()}
        </ShopContext.Provider>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  loginState: state.login,
  tipsInfoState: state.tipsInfo,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getTipInfo: (tipID: string) =>
    dispatch(tipsActions.tipProductRequestAction(tipID)),
  getPricingTiers: () => dispatch(tipsActions.pricingTiersRequestAction()),
  getCoupons: () => dispatch(tipsActions.couponRequestAction()),
});

export const TipWrapperConnected = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TipWrapper),
);
